import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Phone } from "lucide-react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Manifesto from "@/components/site/Manifesto";
import Services from "@/components/site/Services";
import Gallery from "@/components/site/Gallery";
import Estimator from "@/components/site/Estimator";
import Reviews from "@/components/site/Reviews";
import QuoteForm from "@/components/site/QuoteForm";
import CallBanner from "@/components/site/CallBanner";
import Footer from "@/components/site/Footer";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#0B0C0E] text-zinc-100 antialiased">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Services />
        <Gallery />
        <Reviews />
        <Estimator />
        <QuoteForm />
        <CallBanner />
      </main>
      <Footer />

      {/* Mobile sticky call bar */}
      <a
        href="tel:+19183997313"
        data-testid="mobile-sticky-call-bar"
        className="fixed bottom-0 left-0 right-0 z-50 flex items-center justify-center gap-3 bg-[#FF5A00] py-4 font-display text-xl tracking-widest text-[#0B0C0E] md:hidden"
      >
        <Phone className="h-5 w-5" strokeWidth={2.5} />
        CALL 918-399-7313
      </a>

      <Toaster theme="dark" position="top-center" />
    </div>
  );
}
